export const onClient = (fn: Function) =>
  import.meta.client ? fn() : undefined;

export const onServe = (fn: Function) =>
  import.meta.server ? fn() : undefined;

export const onDiff = <T=any>(cfn: Function, sfn: Function):T => {
  return import.meta.client ? cfn() : sfn();
};

/** 服务端同步执行，客户端异步执行 */
export const onSide = (fn: Function) => {
  const a = useState(() => false);
  return onDiff(
    () => {
      if (!a.value) {
        fn();
      } else {
        a.value = false;
      }
    },
    () => {
      if (!a.value) {
        a.value = true;
        return fn();
      }
    }
  );
};

export function randomId(): string {
  // 取时间戳后6位 + 4位随机字符
  return Date.now().toString(36).slice(-6) + 
         Math.random().toString(36).substring(2, 6);
}

export const randomKey = (key) => `${randomId()}_${key}`;